import React, { useState, useEffect } from 'react';

// Material
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import Grid from '@mui/material/Grid';

// Components
import Textfield from '../../../../components/inputs/input';
import Dropdown from '../../../../components/inputs/dropdown';
import Autocomplete from '../../../../components/inputs/Autocomplete';

// Hooks
import useNotify from '../../../../hooks/notify';
import useUser from '../../../../hooks/user/useUser';
import useWarehouse from '../../../../hooks/warehouse/useWarehouse';

const defaultFilters = { active: true, pageSize: 10 };

const SaveMovementModal = ({ movement, onChange, onSave, onClose, open, title, description }) => {
    //States
    const [error, setError] = useState(false);
    const [selectedDestinationWarehouse, setSelectedDestinationWarehouse] = useState();

    //Hooks
    const { branch } = useUser();
    const { Notify, variants } = useNotify();
    const { warehouses, loading, filters, setFilters } = useWarehouse({
        ...defaultFilters,
        country: branch?.country,
    });

    //Effects
    useEffect(() => {
        onChange({ warehouseId: branch?.warehouseId, branchCode: branch?.code });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branch])

    useEffect(() => {
        if (warehouses?.length > 0) {
            const selected = warehouses?.find(w => w.id === movement?.warehouseDestinationId);
            setSelectedDestinationWarehouse(selected);
        }
    }, [movement, warehouses])

    //Handlers
    const handleReasonChange = (e) => {
        setError(!e.target.value);
        onChange({ reason: e.target.value })
    }

    const handleValueChange = (event) => {
        onChange({ [event.target.name]: event.target.value });
    }

    const handleSave = () => {
        if (!movement.reason) {
            setError(true);
            Notify("Debe ingresar un motivo por el movimiento", variants.ERROR);
            return;
        }
        if (!movement.warehouseDestinationId && !movement?.id) {
            setError(true);
            Notify("Debe seleccionar un destino", variants.ERROR);
            return;
        }

        onSave();
        onClose();
    }

    const handleAutocompleteValueChange = (name, value) =>
        onChange({ [name]: value?.id });

    let timerId;
    const handleWarehouseAutocompleteInputChange = (event, value) => {
        if (event?._reactName !== 'onClick' || value === "") {
            clearTimeout(timerId);
            timerId = setTimeout(() => setFilters({ ...filters, textFilter: value }), 500);
        }
    }

    const GetWarehouse = () => {
        if (!branch.warehouseId || !warehouses)
            return [];
        return warehouses.filter(w => w.id !== branch.warehouseId)
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent style={{ minWidth: 430 }}>
                <DialogContentText id="alert-dialog-description">
                    {description}
                </DialogContentText>
                <Grid container direction='column'>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Textfield
                                required
                                fullWidth
                                multiline
                                rows={5}
                                name='reason'
                                label='Motivo'
                                onChange={handleReasonChange}
                                value={movement.reason}
                                error={error}
                            />
                        </Grid>
                        {
                            !movement?.id &&
                            <>
                                <Grid size={12}>
                                    <Dropdown
                                        disabled
                                        required
                                        fullWidth
                                        name='warehouseId'
                                        label='Origen'
                                        error={error}
                                        onChange={handleValueChange}
                                        getOptionValue={(option) => option?.warehouseId}
                                        getOptionLabel={(option) => option?.name}
                                        value={movement?.warehouseId || ""}
                                        values={[branch] || []}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Autocomplete
                                        required
                                        fullWidth
                                        loading={loading}
                                        loadingText='Buscando depositos...'
                                        TextProps={{ label: 'Seleccionar Destino' }}
                                        onChange={(e, value) => handleAutocompleteValueChange('warehouseDestinationId', value)}
                                        onInputChange={handleWarehouseAutocompleteInputChange}
                                        getOptionLabel={(option) => option.name || ''}
                                        value={selectedDestinationWarehouse || ''}
                                        options={GetWarehouse()}
                                    />
                                </Grid>
                            </>

                        }
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant='outlined'
                    autoFocus
                >
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SaveMovementModal;